import { LoginLogo } from "@/features/auth/components/LoginLogo";
import { ResetPasswordForm } from "@/features/auth/components/ResetPasswordForm";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";

type TResetPasswordPageProps = {};

export const ResetPasswordPage: FC<TResetPasswordPageProps> = () => {
  return (
    <Stack gap={6} alignItems="center">
      <LoginLogo />
      <Typography variant="head20Bold">パスワードの再発行</Typography>
      <ResetPasswordForm />
    </Stack>
  );
};
